import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonVerticalScoreComponent } from './mon-vertical-score/mon-vertical-score.component';
import { MonChartsModule } from '@monsido/angular-shared-components';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';


@NgModule({
    declarations: [MonVerticalScoreComponent],
    imports: [
        CommonModule,
        MonChartsModule,
        NgbTooltipMfeModule,
    ],
    exports: [MonVerticalScoreComponent],
})
export class MonScoreComponentsModule {}
